export type SearchViewType = AistudioSearchCategoryV2Form['searchViewType'] | string;

export type SearchResultWithView = AistudioSearchQueryDto & {
    /**
     * Client-side discriminator copied from the request that produced this result.
     * The v2 API can return the same categoryId/categoryType for multiple views
     * (notably precedent and decisions_and_interpretations), so UI buckets must not
     * rely on the backend category metadata alone.
     */
    searchViewType?: SearchViewType;
};

export type SearchCategoryBucketInput = {
    categoryId?: string | number | null;
    searchViewType?: SearchViewType | null;
};

export const createSearchResultBucketKey = ({ categoryId, searchViewType }: SearchCategoryBucketInput): string => {
    const normalizedCategoryId = categoryId == null ? '' : String(categoryId);
    return searchViewType ? `${searchViewType}:${normalizedCategoryId}` : normalizedCategoryId;
};

export const getSearchResultViewType = (item: { searchViewType?: SearchViewType | null } | null | undefined): SearchViewType | null => item?.searchViewType ?? null;

export const getCategoryTypeHintForSearchResult = (item: SearchResultWithView): AistudioSearchQueryDto['categoryType'] => {
    switch (item.searchViewType) {
        case 'precedent':
            return 'PRECEDENT';
        case 'decisions_and_interpretations':
            return 'DECISIONS_AND_INTERPRETATIONS';
        case 'law':
            return 'LAW';
        case 'miscellaneous':
            return 'MISCELLANEOUS';
        default:
            return item.categoryType;
    }
};
